(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("TierPriceModalCtrl", ["$scope", "tierPriceResource", "tierPrice", "messageService", tierPriceModalCtrl]);
    function tierPriceModalCtrl($scope, tierPriceResource, tierPrice, messageService) {
        var vm = this;
        vm.showErrors = false;
        vm.saving = false;
        vm.loading = true;
        var params = {};
        if (tierPrice)
            params.id = tierPrice.id;
        tierPriceResource.get(params, function (data) {
            vm.model = data;
            vm.onlyOneEnabled = vm.model.tierPriceLocalizations.length === 1;
            vm.loading = false;
        });
        vm.save = function () {
            if (!vm.form.$valid) {
                vm.showErrors = true;
                return;
            }
            vm.saving = true;
            tierPriceResource.save(vm.model, function (data) {
                messageService.success("common.changesSaved");
                $scope.$close(data);
            }, function () {
                messageService.error("common.genericError");
            });
        };
    }
}());
